import {
  QueryClient,
  QueryClientProvider,
  useQueryClient,
} from '@tanstack/react-query'
import { useState } from 'react'
import {
  BrowserRouter,
  Route,
  Routes,
  useNavigate,
} from 'react-router-dom'

import { RoadmapHeader } from './components/RoadmapHeader'
import { SubmitIdeaModal } from './components/SubmitIdeaModal'
import { BoardPage } from './pages/BoardPage'
import { PostDetailPage } from './pages/PostDetailPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
})

const Shell = (): JSX.Element => {
  const [modalOpen, setModalOpen] = useState(false)
  const navigate = useNavigate()
  const client = useQueryClient()

  return (
    <div className="min-h-dvh bg-dune-bg">
      <RoadmapHeader onSubmitIdea={() => setModalOpen(true)} />

      <Routes>
        <Route
          path="/"
          element={<BoardPage onSubmitIdea={() => setModalOpen(true)} />}
        />
        <Route path="/posts/:id" element={<PostDetailPage />} />
      </Routes>

      <footer className="border-t border-dune-border py-8">
        <div className="mx-auto flex w-full max-w-5xl flex-col items-center gap-3 px-4 text-center sm:px-8">
          <div className="flex items-center gap-5">
            <a
              href="https://hodle.com.br"
              target="_blank"
              rel="noreferrer"
              className="font-display text-sm text-dune-text-secondary transition-colors hover:text-dune-text"
            >
              hodle.com.br
            </a>
            <a
              href="https://app.hodle.com.br"
              target="_blank"
              rel="noreferrer"
              className="font-display text-sm text-dune-text-secondary transition-colors hover:text-dune-text"
            >
              Abrir app
            </a>
          </div>
          <p className="text-xs text-dune-text-secondary">
            Roadmap público da Hodle · infraestrutura cripto para empresas
          </p>
        </div>
      </footer>

      <SubmitIdeaModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreated={(post) => {
          setModalOpen(false)
          client.invalidateQueries({ queryKey: ['posts'] })
          client.invalidateQueries({ queryKey: ['meta'] })
          navigate(`/posts/${post.id}`)
        }}
      />
    </div>
  )
}

export const App = (): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  </QueryClientProvider>
)
